export default __webpack_public_path__ + "static/media/seeker-3.70c838ae.jpg";